import { backendApi } from '@app/services'

type ActAsBuyerPayload = {
  userId: number
  accountId: number
}

export const actAsBuyer = async ({ userId, accountId }: ActAsBuyerPayload) => {
  await backendApi.post('/users/act-as', {
    userId,
    accountId,
  })
}

export const clearActAsBuyer = async () => {
  await backendApi.delete('/users/act-as')
}
